/** Wraps a [ResizeObserver](https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver) to allow tracking `DOMRect` dimensions */
export class EsResizeObserver {
    constructor() {
        this.observer = new ResizeObserver(([entry]) => {
            this.sizeChanged.emit(entry.contentRect);
        });
    }
    componentDidLoad() {
        this.observer.observe(this.host);
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    static get is() { return "es-resize-observer"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-resize-observer.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-resize-observer.css"]
        };
    }
    static get events() {
        return [{
                "method": "sizeChanged",
                "name": "sizeChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Triggered when the size of the element changes."
                },
                "complexType": {
                    "original": "DOMRectReadOnly",
                    "resolved": "DOMRectReadOnly",
                    "references": {
                        "DOMRectReadOnly": {
                            "location": "global",
                            "id": "global::DOMRectReadOnly"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-resize-observer.js.map
